<template>
  <div>
    <v-select
      v-model="grade_subject_id"
      class="px-2"
      :items="gradeSubjects"
      item-text="name"
      item-value="id"
      label="Disciplinas"
      :disabled="gradeSubjects.length === 0"
    >
      <template
        v-if="grade_subject_id !== null"
        #append
      >
        <v-btn
          color="primary"
          text
          @click="grade_subject_id = null"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-select>
  </div>
</template>

<script>
import handlesServerValidation from '@/mixins/handles-server-validation.js'
export default {
  mixins: [
    handlesServerValidation
  ],
  props: {
    gradeId: { type: Number, default: undefined },
    gradeSubjectIdSelected: { type: Number, default: undefined }
  },
  data: () => ({
    gradeSubjects: [],
    grade_subject_id: null
  }),
  watch: {
    grade_subject_id () {
      this.setGradeSubject()
    },
    async gradeId () {
      if (this.gradeId) {
        await this.listGradeSubjects()
        this.gradeSubjects.find(gradeSubject => gradeSubject.id === this.gradeSubjectIdSelected) && (this.grade_subject_id = this.gradeSubjectIdSelected)
      } else {
        this.gradeSubjects = []
        this.grade_subject_id = null
        this.setGradeSubject()
      }
    }
  },

  methods: {
    setGradeSubject () {
      const name = this.gradeSubjects.find(g => g.id === this.grade_subject_id)?.name
      this.$emit('setGradeSubjectName', name)
      this.$emit('setGradeSubject', this.grade_subject_id)
    },
    async listGradeSubjects () {
      try {
        this.gradeSubjects = await this.$api.listGradeSubjects(this.gradeId)
        this.grade_subject_id = null
      } catch (e) {
        this.getErrors(e)
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível obter as disciplinas, tente novamente mais tarde.', color: 'red' })
      }
    }
  }
}
</script>
